// ======================================================================
// File Name       : LiveUserAttributeEdit
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, FormControl, Form } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';

class LiveUserAttributeEdit extends React.Component {
  render() {
    const attributeList = [...Array(20)].map((val, index) => {
      const keyNum = index + 1;
      return (
        <Form.Group key={index} className="form-info">
          <Col as={Form.Label} sm={3}>
            自由記述領域{keyNum}
          </Col>
          <Col sm={7}>
            <RenderField type="text" name={`userAttributes.${index}`} maxLength={16384} />
          </Col>
        </Form.Group>
      );
    });
    return <div>{attributeList}</div>;
  }
}

export default LiveUserAttributeEdit;
